// TODO: Add following options again as soon as required
//  (...they are in the TOPAS standard and will come back...)
// export type LayingType =
//   'CLOSED' |
//   'JETTING' |
//   'OPEN' |
//   'OTHER' |
//   'PLOUGH' |
//   'SOIL_DISPLACEMENT' |
//   'TRENCH_MT1' |
//   'TRENCH_MT2' |
//   'TRENCH_MT3' |
//   'TRENCH_MT4' |
// }

export const layingTypes = [
  'SOIL_DISPLACEMENT',
  'PULL',
  'HORIZONTAL_DIRECTIONAL_DRILLING',
  'PLOUGH',
  'LAYJET',
  'MICRO_TRENCHING',
  'CLAMPED',
  'OVERGROUND',
  'HAND_DIGGING',
  'NOT_APPLICABLE',
] as const;

export const roadContexts = ['STREET_CROSSING', 'NOT_APPLICABLE'] as const;

export type RoadContext = (typeof roadContexts)[number];

export type LayingType = (typeof layingTypes)[number];

export const surfaceTypes = [
  'ASPHALT',
  'UNPAVED_GRASS',
  'SIMPLE_BRICK',
  'CONCRETE',
  'HIGH_QUALITY_BRICK',
  'MISSING',
  'NOT_APPLICABLE',
] as const;

export const defaultDepths = [
  'SIZE_45_CM',
  'SIZE_50_CM',
  'SIZE_55_CM',
  'SIZE_60_CM',
  'SIZE_65_CM',
  'SIZE_70_CM',
  'SIZE_75_CM',
  'SIZE_80_CM',
  'SIZE_85_CM',
  'SIZE_90_CM',
  'SIZE_95_CM',
  'SIZE_100_CM',
] as const;

export const smallerDepths = [
  'NOT_APPLICABLE',
  'SIZE_0_CM',
  'SIZE_5_CM',
  'SIZE_10_CM',
  'SIZE_15_CM',
  'SIZE_20_CM',
  'SIZE_25_CM',
  'SIZE_30_CM',
  'SIZE_35_CM',
  'SIZE_40_CM',
] as const;

export const biggerDepths = [
  'SIZE_105_CM',
  'SIZE_110_CM',
  'SIZE_115_CM',
  'SIZE_120_CM',
  'SIZE_125_CM',
  'SIZE_130_CM',
  'SIZE_135_CM',
  'SIZE_140_CM',
  'SIZE_145_CM',
  'SIZE_150_CM',
  'SIZE_155_CM',
  'SIZE_160_CM',
  'SIZE_165_CM',
  'SIZE_170_CM',
  'SIZE_175_CM',
  'SIZE_180_CM',
  'SIZE_185_CM',
  'SIZE_190_CM',
  'SIZE_200_CM',
  'SIZE_205_CM',
  'SIZE_210_CM',
  'SIZE_215_CM',
  'SIZE_220_CM',
  'SIZE_225_CM',
  'SIZE_230_CM',
  'SIZE_235_CM',
  'SIZE_240_CM',
  'SIZE_245_CM',
  'SIZE_250_CM',
  'SIZE_255_CM',
  'SIZE_260_CM',
  'SIZE_265_CM',
  'SIZE_270_CM',
  'SIZE_275_CM',
  'SIZE_280_CM',
  'SIZE_285_CM',
  'SIZE_290_CM',
  'SIZE_295_CM',
  'SIZE_300_CM',
] as const;

export const depths = [...defaultDepths, ...smallerDepths, ...biggerDepths] as const;
export const depthsSorted = [...smallerDepths, ...defaultDepths, ...biggerDepths] as const;

export const defaultWidths = [
  'NOT_APPLICABLE',
  'SIZE_0_CM',
  'SIZE_5_CM',
  'SIZE_10_CM',
  'SIZE_15_CM',
  'SIZE_20_CM',
  'SIZE_25_CM',
  'SIZE_30_CM',
  'SIZE_35_CM',
  'SIZE_40_CM',
  'SIZE_45_CM',
] as const;

export const biggerWidths = [
  'SIZE_50_CM',
  'SIZE_55_CM',
  'SIZE_60_CM',
  'SIZE_65_CM',
  'SIZE_70_CM',
  'SIZE_75_CM',
  'SIZE_80_CM',
  'SIZE_85_CM',
  'SIZE_90_CM',
  'SIZE_95_CM',
  'SIZE_100_CM',
  'SIZE_105_CM',
  'SIZE_110_CM',
  'SIZE_115_CM',
  'SIZE_120_CM',
  'SIZE_125_CM',
  'SIZE_130_CM',
  'SIZE_135_CM',
  'SIZE_140_CM',
  'SIZE_145_CM',
  'SIZE_150_CM',
  'SIZE_155_CM',
  'SIZE_160_CM',
  'SIZE_165_CM',
  'SIZE_170_CM',
  'SIZE_175_CM',
  'SIZE_180_CM',
  'SIZE_185_CM',
  'SIZE_190_CM',
  'SIZE_195_CM',
  'SIZE_200_CM',
] as const;

export const widths = [...defaultWidths, ...biggerWidths] as const;

export type SurfaceType = (typeof surfaceTypes)[number];

export const attributeTypes = [
  'LAYING_TYPE',
  'SURFACE_TYPE',
  'DEPTH',
  'WIDTH',
  'ROAD_CONTEXT',
] as const;

export type AttributeType = (typeof attributeTypes)[number];

export type Depth = (typeof depths)[number];

export type Width = (typeof widths)[number];
